import { render } from "./ShowXray.vue?vue&type=template&id=73491ff6&scoped=true"
import script from "./ShowXray.vue?vue&type=script&lang=js"
export * from "./ShowXray.vue?vue&type=script&lang=js"

import "./ShowXray.vue?vue&type=style&index=0&id=73491ff6&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73491ff6"]])

export default __exports__